import { AuthData } from "@app/store/models/auth-data.interface";
import { select, Store } from "@ngrx/store";
import { lastValueFrom } from "rxjs";
import { take } from "rxjs/operators";
import { StateStatuses } from "../../../../store/enums/state-statuses.enum";
import { APIResponse, LoginResponse } from "shared-library";
import { selectAuthState } from "../selectors/auth.selectors";

export interface AuthState {
  error: string;
  data: AuthData;
  status: StateStatuses;
  responses: {
    signup: APIResponse;
    login: LoginResponse;
  }
}

export const getAuthState = (store: Store): Promise<AuthState> => {
  return lastValueFrom(store.pipe(
    select(selectAuthState),
    take(1)
  ));
}
